<div class="flex gap-2">
  <app-pan-button icon="remove" (click)="params.minusCallback(params.data)"></app-pan-button>

  <span class="mx-3">
    {{ params.data.quantity }}
  </span>

  <app-pan-button icon="add" (click)="params.plusCallback(params.data)"></app-pan-button>
</div>
